<template>
  <div>
    <div class="content">
      <div class="header">
        <div class='list'>
          <div class='listTitle'>
            <div class='listTitleText'>
              {{compLists.d2CorpName || $route.query.keyword }}</div>
            <!--            <div class='status'>{{compLists.d2EntStatus}}</div>-->
          </div>
          <!--          <div class='listBtn'>统一社会信用代码：{{compLists.corpKey}}</div>-->
        </div>
      </div>
      <!--      <div class='basis'>-->
      <!--        <div class="title">基础信息</div>-->
      <!--        <div class="titleTop">-->

      <!--          <div-->
      <!--            class="state"-->
      <!--            style="border-bottom: 1px solid #e8e9f2;"-->
      <!--          >法定代表人/负责人/执行事务合伙人</div>-->
      <!--          <div class="stateContent">{{compLists.d2LegalPer}}</div>-->
      <!--          <div-->
      <!--            class="state"-->
      <!--            style="border-bottom: 1px solid #e8e9f2"-->
      <!--          >企业类型</div>-->
      <!--          <div class="stateContent">{{compLists.d2EntType}}</div>-->
      <!--        </div>-->
      <!--        <div class="titleTop">-->
      <!--          <div class="state">成立日期</div>-->
      <!--          <div class="stateContent">{{compLists.d2EsDate}}</div>-->
      <!--          <div class="state">住所</div>-->
      <!--          <div class="stateContent">{{compLists.d2Dom}}</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div
        class="basisList"
        style="padding-top: 20px"
      >
        <!-- <div
          v-for='(item,index) in basisList'
          :key="index"
          class="listSon"
          :class="{chooselistSon:index == nowIndex}"
          @click="toggleTabs(index)"
        > <img :src="item.src"><span>{{item.span}}</span><span
            class="colortxt">{{item.number}}</span>
        </div> -->
        <div
          class="listSon"
          :class="{chooselistSon:0 === nowIndex}"
          @click="toggleTabs(0)"
        > <img
            src="../../assets/imgs/publicCredit/1 拷贝.png"><span>行政许可</span><span
            class="colortxt"
          >{{Xzxktxt}}</span>
        </div>
        <div
          class="listSon"
          :class="{chooselistSon:1 === nowIndex}"
          @click="toggleTabs(1)"
        > <img
            src="../../assets/imgs/publicCredit/2 拷贝.png"><span>行政处罚</span><span
            class="colortxt"
          >{{Xzcftxt}}</span>
        </div>
        <div
          class="listSon"
          :class="{chooselistSon:2 === nowIndex}"
          @click="toggleTabs(2)"
        > <img
            src="../../assets/imgs/publicCredit/3 拷贝.png"><span>守信激励</span><span
            class="colortxt"
          >{{Sxjltxt}}</span>
        </div>
        <div
          class="listSon"
          :class="{chooselistSon:3 === nowIndex}"
          @click="toggleTabs(3)"
        > <img
            src="../../assets/imgs/publicCredit/4 拷贝.png"><span>失信惩戒</span><span
            class="colortxt"
          >{{Sxcjtxt}}</span>
        </div>
        <div
          class="listSon"
          :class="{chooselistSon:4 === nowIndex}"
          @click="toggleTabs(4)"
        > <img
            src="../../assets/imgs/publicCredit/5 拷贝.png"><span>重大税收违法</span><span
            class="colortxt"
          >{{Zdsswftxt}}</span>
        </div>
        <div
          class="listSon"
          :class="{chooselistSon:5 === nowIndex}"
          @click="toggleTabs(5)"
        > <img
            src="../../assets/imgs/publicCredit/6 拷贝.png"><span>安全生产失信</span><span
            class="colortxt"
          >{{Aqsctxt}}</span>
        </div>
        <div
          class="listSon"
          :class="{chooselistSon:6 === nowIndex}"
          @click="toggleTabs(6)"
        > <img
            src="../../assets/imgs/publicCredit/7 拷贝.png"><span>严重拖欠工资</span><span
            class="colortxt"
          >{{Qnmggztxt}}</span>
        </div>
        <!-- <div
          class="listSon"
          :class="{chooselistSon:7 === nowIndex}"
          @click="toggleTabs(7)"
        > <img
            src="../../assets/imgs/publicCredit/8 拷贝.png"><span>信用评分</span><span
            class="colortxt"
          >{{XYPFText}}</span>
        </div> -->
      </div>
      <!-- 1.行政许可 -->
      <div
        class="illegalDetails"
        v-if="nowIndex ===0"
      >
        <div
          v-for='(item,index) in XzxkList'
          :key="index"
        >
          <div class="title">第{{index+1}}条</div>
          <div class="illegalDetailsBox">
            <div class="DetailsBox">
              <div class="boxState">行政许可决定文书号</div>
              <div class="boxCont">{{item.entity.xk_wsh}}</div>
              <div class="boxState">行政许可决定文书名称</div>
              <div class="boxCont">{{item.entity.xk_xkws}}</div>
            </div>
            <div class="DetailsBox">
              <div class="boxState">许可证书名称</div>
              <div class="boxCont">{{item.entity.xk_xkws}}</div>
              <div class="boxState">许可类别</div>
              <div class="boxCont">{{item.entity.xk_xklb}}</div>
            </div>
            <div class="DetailsBox">
              <div class="boxState">许可编号</div>
              <div class="boxCont">{{item.entity.recid}}</div>
              <div class="boxState">许可决定日期</div>
              <div class="boxCont">{{item.entity.xk_jdrq}}</div>
            </div>
            <div class="DetailsBox">
              <div class="boxState">有效期自</div>
              <div class="boxCont">{{item.entity.xk_yxqz}}</div>
              <div class="boxState">有效期至</div>
              <div class="boxCont">{{item.entity.xk_yxqzi}}</div>
            </div>
            <div class="xuke">
              <div class="left">许可内容</div>
              <div class="right">{{item.entity.xk_nr}}</div>
            </div>
            <div class="DetailsBox">
              <div class="boxState">许可机关</div>
              <div class="boxCont">{{item.entity.xk_xkjg}}</div>
              <div class="boxState">许可机关统一社会信用代码</div>
              <div class="boxCont">{{item.entity.xk_xkjg}}</div>
            </div>
            <div class="DetailsBox">
              <div class="boxState">数据来源单位</div>
              <div class="boxCont">{{item.entity.xk_lydw}}</div>
              <div class="boxState">数据来源单位统一社会信用代码</div>
              <div class="boxCont">{{item.entity.xk_lydwdm}}</div>
            </div>
          </div>
        </div>
        <!-- 暂无数据 -->
        <div
          class="noData"
          v-show="Xzxktxt==0"
        >
          <img
            v-if='Xzxktxtimg==0'
            src="../../assets/imgs/publicCredit/没有数据.png"
          >
          <img
            v-if='Xzxktxtimg==1'
            src="../../assets/imgs/publicCredit/loading.gif"
          >
        </div>
      </div>
      <!-- 2.行政处罚 -->
      <div
        class="administrative"
        v-show="nowIndex ===1"
      >
        <div
          v-for="(item,index)  in XzcfList"
          :key="index"
        >
          <div class="title">第{{index+1}}条</div>
          <div class="illegalDetailsBox">
            <div class="DetailsBox">
              <div class="boxState">行政许可决定文书号</div>
              <div class="boxCont">{{item.entity.cf_wsh}}</div>
              <div class="boxState">处罚类别</div>
              <div class="boxCont">{{item.entity.cf_cflb}}</div>
            </div>
            <div class="DetailsBox">
              <div class="boxState">处罚决定日期</div>
              <div class="boxCont">{{item.entity.cf_jdrq}}</div>
              <div class="boxState">处罚内容</div>
              <div class="boxCont">{{item.entity.cf_nr}}</div>
            </div>
            <div class="DetailsBox">
              <div class="boxState">罚款金额（万元）</div>
              <div class="boxCont">{{item.entity.cf_nr_fk}}</div>

              <div style=" width: 200px;color:#7B7B7D;padding:5px 10px;
          box-sizing: border-box;
          font-size: 14px;">没收违法所得、没收非法财物的金额(万元)
              </div>
              <div class="boxCont">{{item.entity.cf_nr_wfff}}</div>
            </div>
            <div class="xuke">
              <div class="left">暂扣或吊销证照名称及编号
              </div>
              <div class="right">{{item.entity.repairState}}</div>
            </div>
            <div class="xuke">
              <div class="left">违法行为类型

              </div>
              <div class="right">{{item.entity.cf_wfxw}}</div>
            </div>
            <div class="xuke">
              <div class="left">违法事实
              </div>
              <div class="right">{{item.entity.cf_sy}}</div>
            </div>
            <div class="xuke">
              <div class="left">处罚依据
              </div>
              <div class="right">{{item.entity.cf_yj}}</div>
            </div>
            <div class="DetailsBox">
              <div class="boxState">处罚机关</div>
              <div class="boxCont">{{item.entity.cf_cfjg}}</div>
              <div class="boxState">处罚机关统一社会信用代码</div>
              <div class="boxCont">{{item.entity.cf_cfjgdm}}</div>
            </div>
            <div class="DetailsBox">
              <div class="boxState">数据来源</div>
              <div class="boxCont">{{item.entity.cf_sjly}}</div>
              <div class="boxState">数据来源单位统一社会信用代码</div>
              <div class="boxCont">{{item.entity.cf_sjlydm}}</div>
            </div>
          </div>
        </div>
        <!-- 暂无数据 -->
        <div
          class="noData"
          v-if="Xzcftxt==0"
        >
          <img
            v-if="xzcfimg==0"
            src="../../assets/imgs/publicCredit/没有数据.png"
          >
          <img
            v-if='xzcfimg==1'
            src="../../assets/imgs/publicCredit/loading.gif"
          >
        </div>
      </div>
      <!-- 3.守信激励 -->
      <div
        class="trustworthyIncentive"
        v-show="nowIndex ===2"
      >
        <div
          v-for="(item,index) in SxjlList"
          :key="index"
        >
          <div class="title">第{{index+1}}条数据</div>
          <div class="illegalDetailsBox">
            <div class="xuke">
              <div class="left">纳税人名称
              </div>
              <div class="right"> {{item.entity.nsrmc}}</div>
            </div>
            <div class="xuke">
              <div class="left">纳税人识别号
              </div>
              <div class="right">{{item.entity.nsrsbh}}</div>
            </div>
            <div class="xuke">
              <div class="left">统一社会信用代码
              </div>
              <div class="right">{{item.entity.tyshxydm}}</div>
            </div>
            <div class="xuke">
              <div class="left">评价年度
              </div>
              <div class="right">{{item.entity.pjnd}}</div>
            </div>
          </div>
        </div>
        <!-- 暂无数据 -->
        <div
          class="noData"
          v-if="Sxjltxt==0"
        >
          <img
            v-if="sxjlimg == 0"
            src="../../assets/imgs/publicCredit/没有数据.png"
          >
          <img
            v-if='sxjlimg==1'
            src="../../assets/imgs/publicCredit/loading.gif"
          >
        </div>
      </div>
      <!-- 4.失信惩戒 -->
      <div
        class="disciplinary"
        v-show="nowIndex ===3"
      >
        <div
          v-for="(item,index) in SxcjList"
          :key="index"
        >
          <div class="title">第{{index+1}}条数据</div>
          <div class="illegalDetailsBox">
            <div class="xuke">
              <div class="left">企业名称
              </div>
              <div class="right"> {{item.entity.qymc}}</div>
            </div>
            <div class="xuke">
              <div class="left">统一社会信用代码/工商注册号
              </div>
              <div class="right">{{item.entity.tyshxydm}}</div>
            </div>
            <div class="xuke">
              <div class="left">组织机构代码
              </div>
              <div class="right">{{item.entity.zzjgdm}}</div>
            </div>
            <div class="xuke">
              <div class="left">法定代表人
              </div>
              <div class="right">{{item.entity.fddbr}}</div>
            </div>
            <div class="xuke">
              <div class="left">案号
              </div>
              <div class="right">{{item.entity.ah}}</div>
            </div>
            <div class="xuke">
              <div class="left">执行法院
              </div>
              <div class="right">{{item.entity.zxfy}}</div>
            </div>
            <div class="xuke">
              <div class="left">省份
              </div>
              <div class="right">{{item.entity.sf}}</div>
            </div>
          </div>
        </div>
        <!-- 暂无数据 -->
        <div
          class="noData"
          v-if="Sxcjtxt==0"
        >
          <img
            v-if="sxcjimg == 0"
            src="../../assets/imgs/publicCredit/没有数据.png"
          >
          <img
            v-if='sxcjimg==1'
            src="../../assets/imgs/publicCredit/loading.gif"
          >
        </div>
      </div>
      <!-- 5.重大税收违法 -->
      <div
        class="taxViolation"
        v-show="nowIndex ===4"
      >
        <div
          v-for="(item,index) in Zdsswf"
          :key="index"
        >
          <div class="title">第{{index+1}}条数据</div>
          <div class="illegalDetailsBox">
            <div class="xuke">
              <div class="left">法定代表人或负责人姓名
              </div>
              <div class="right"> {{item.fddbrhzfzrmc}}</div>
            </div>
            <div class="xuke">
              <div class="left">统一社会信用代码
              </div>
              <div class="right">{{item.tyshxydm}}</div>
            </div>
            <div class="xuke">
              <div class="left">纳税人名称
              </div>
              <div class="right">{{item.nsrmc}}</div>
            </div>
            <div class="xuke">
              <div class="left">纳税人识别号
              </div>
              <div class="right">{{item.nsrsbh}}</div>
            </div>
            <div class="xuke">
              <div class="left">案件性质
              </div>
              <div class="right">{{item.ajxz}}</div>
            </div>
            <div class="xuke">
              <div class="left">负有直接责任的财务负责人姓名
              </div>
              <div class="right">{{item.zxfy}}</div>
            </div>
            <div class="xuke">
              <div class="left">负有直接责任的中介机构信息及其从业人员信息
              </div>
              <div class="right">{{item.sf}}</div>
            </div>
            <div class="xuke">
              <div class="left">相关法律依据及税务处理处罚情况
              </div>
              <div class="right">{{item.sf}}</div>
            </div>
            <div class="xuke">
              <div class="left">主要违法事实
              </div>
              <div class="right">{{item.zywfss}}</div>
            </div>
            <div class="xuke">
              <div class="left">组织机构代码
              </div>
              <div class="right">{{item.zzjgdm}}</div>
            </div>
            <div class="xuke">
              <div class="left">案件上报期
              </div>
              <div class="right">{{item.sf}}</div>
            </div>
            <div class="xuke">
              <div class="left">相关法律依据及税务处理处罚情况
              </div>
              <div class="right">{{item.sf}}</div>
            </div>
          </div>
        </div>
        <!-- 暂无数据 -->
        <div
          class="noData"
          v-if="Zdsswftxt==0"
        >
          <img
            v-if="zdsswfimg == 0"
            src="../../assets/imgs/publicCredit/没有数据.png"
          >
          <img
            v-if='zdsswfimg==1'
            src="../../assets/imgs/publicCredit/loading.gif"
          >
        </div>
      </div>
      <!-- 6.安全生产失信 -->
      <div
        class="production"
        v-show="nowIndex ===5"
      >
        <div
          v-for="(item,index) in Aqsc"
          :key="index"
        >
          <div class="title">第{{index+1}}条数据</div>
          <div class="illegalDetailsBox">
            <div class="xuke">
              <div class="left">单位名称
              </div>
              <div class="right">{{item.dwmc}}</div>
            </div>
            <div class="xuke">
              <div class="left">统一社会信用代码/工商注册号
              </div>
              <div class="right">{{item.nrly}}</div>
            </div>
            <div class="xuke">
              <div class="left">失信行为简况
              </div>
              <div class="right">{{item.sxxwjk}}</div>
            </div>
            <div class="xuke">
              <div class="left">纳入理由
              </div>
              <div class="right">{{item.nrly}}</div>
            </div>
            <div class="xuke">
              <div class="left">主要负责人
              </div>
              <div class="right">{{item.zyfzr}}</div>
            </div>
            <div class="xuke">
              <div class="left">注册地址
              </div>
              <div class="right">{{item.zcdz}}</div>
            </div>
            <div class="xuke">
              <div class="left">信息报送机关
              </div>
              <div class="right">{{item.xxbsjg}}</div>
            </div>
          </div>
        </div>
        <!-- 暂无数据 -->
        <div
          class="noData"
          v-if="Aqsctxt==0"
        >
          <img
            v-if="aqscsximg == 0"
            src="../../assets/imgs/publicCredit/没有数据.png"
          >
          <img
            v-if='aqscsximg==1'
            src="../../assets/imgs/publicCredit/loading.gif"
          >
        </div>
      </div>
      <!-- 7.严重拖欠工资 -->
      <div
        class="wages"
        v-show="nowIndex ===6"
      >
        <div
          v-for="(item,index) in Qnmggz"
          :key="index"
        >
          <div class="title">第{{index+1}}条数据</div>
          <div class="illegalDetailsBox">
            <div class="xuke">
              <div class="left">对象名称
              </div>
              <div class="right">{{item.dxmc}}</div>
            </div>
            <div class="xuke">
              <div class="left">列入日期
              </div>
              <div class="right">{{item.lrrq}}</div>
            </div>
            <div class="xuke">
              <div class="left">文书号
              </div>
              <div class="right">{{item.sxxwjk}}</div>
            </div>
          </div>
        </div>
        <!-- 暂无数据 -->
        <div
          class="noData"
          v-if="Qnmggztxt==0"
        >
          <img
            v-if="yztqgzimg == 0"
            src="../../assets/imgs/publicCredit/没有数据.png"
          >
          <img
            v-if='yztqgzimg==1'
            src="../../assets/imgs/publicCredit/loading.gif"
          >
        </div>
      </div>
      <!--8. 信用评分 -->
      <!-- <div
        class="credit"
        v-show="nowIndex ===7"
      >
        <div v-if='XYPFText!==0'>
          <div class="top">
            <img src="../../assets/imgs/publicCredit/分数环5.png">
            <span class='fenshu'>{{XYPFDetailList.totalScore}}</span>
            <span
              class='level'
              v-show="XYPFDetailList.totalScore>=700"
              style="background-color:#D22D18;"
            >信用优秀</span>
            <span
              class='level'
              v-show="XYPFDetailList.totalScore<700&&XYPFDetailList.totalScore>645"
              style="background-color:#ED5A40;"
            >信用良好</span>
            <span
              class='level'
              v-show="XYPFDetailList.totalScore<645&&XYPFDetailList.totalScore>600"
              style="background-color:#E8924D;"
            >信用一般</span>
            <span
              class='level'
              v-show="XYPFDetailList.totalScore<600&&XYPFDetailList.totalScore>550"
              style="background-color:#56B180;"
            >信用较弱</span>
            <span
              class='level'
              v-show="XYPFDetailList.totalScore<550"
              style="background-color:#4A97B7;"
            >信用最弱</span>
            <span class='btn'>公司最新信用评分</span>
          </div>
          <div style="margin-top:40px;">
            <img
              src="../../assets/imgs/publicCredit/信用等级梯度.png"
              style="width:100%"
            >
          </div>
        </div> -->
      <!-- 暂无数据 -->
      <!-- <div
          class="noData"
          v-if="XYPFText==0"
        >
          <img src="../../assets/imgs/publicCredit/没有数据.png">
        </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import { xzcf_list, xzxk_list, sxjl_list, sxcj_list, zdsswf, aqsc, tqnmggz, compDetail, XYPFDetail } from '@/api/publicCredit'
export default {
  data () {
    return {
      nowIndex: 0,
      now: 0,
      keyword: '',
      XzxkList: [], //行政许可
      XzcfList: [],  //行政处罚
      SxjlList: [], //守信激励
      SxcjList: [],//失信惩戒
      Zdsswf: [],//重大税收违法
      Aqsc: [],//安全生产失信
      Qnmggz: [],//严重拖欠工资
      compLists: [],//公司详情
      // XYPFDetailList: [],//信用评分
      Xzxktxt: 0,
      Xzcftxt: 0,
      Sxjltxt: 0,
      Sxcjtxt: 0,
      Zdsswftxt: 0,
      Aqsctxt: 0,
      Qnmggztxt: 0,
      XYPFText: 0,
      Xzxktxtimg: 1,
      xzcfimg: 1,
      sxjlimg: 1,
      sxcjimg: 1,
      zdsswfimg: 1,
      aqscsximg: 1,
      yztqgzimg: 1,
    }
  },
  created () {
    this.keyword = this.$route.query.keyword
    // this.getCompDetail()
    this.getXzxkList()
    this.getXzcfList()
    this.getSxjlList()
    this.getSxcjList()
    this.getZdsswf()
    this.getAqsc()
    this.gettQnmggz()
  },
  methods: {
    toggleTabs: function (index) {
      this.now = index
      this.nowIndex = index;
      if (this.nowIndex === 0) {
        this.getXzxkList()
      } else if (this.nowIndex === 1) {
        this.getXzcfList()
      } else if (this.nowIndex === 2) {
        this.getSxjlList()
      } else if (this.nowIndex === 3) {
        this.getSxcjList()
      } else if (this.nowIndex === 4) {
        this.getZdsswf()
      } else if (this.nowIndex === 5) {
        this.getAqsc()
      } else if (this.nowIndex === 6) {
        this.gettQnmggz()
      }
      // else if (this.nowIndex === 7) {
      //   this.getXYPFDetail()
      // }
    },
    //公司详情
    // async getCompDetail () {
    //   let param = { companyId: this.keyword }
    //   const res = await compDetail(this.sendParam(param));
    //   let result = this.paramDecrypt(res)
    //   if (result.code == 200) {
    //     this.compLists = result.data
    //   }
    // },
    //行政许可
    getXzxkList () {
      let data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      }
      const res = xzxk_list(this.sendParam(data));
      Promise.resolve(res).then(value => {  //处理返回的Promise
        let key = this.RsaDecrypt(value.data.encrypted)
        let result = JSON.parse(this.AesDecrypt(value.data.requestData, key))
        if (result.code == 200 && res.data !== null) {
          this.XzxkList = result.data.list
          this.Xzxktxt = result.data.total
          if (result.data.total == 0) {
            this.Xzxktxtimg = 0
          }
        } else {
          this.$message.error(result.msg)
        }
      })
    },
    //行政处罚
    getXzcfList () {
      let data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      }
      const res = xzcf_list(this.sendParam(data));
      Promise.resolve(res).then(value => {  //处理返回的Promise
        let key = this.RsaDecrypt(value.data.encrypted)
        let result = JSON.parse(this.AesDecrypt(value.data.requestData, key))
        if (result.code == 200 && res.data !== null) {
          this.XzcfList = result.data.list
          this.Xzcftxt = result.data.total
          if (result.data.total == 0) {
            this.xzcfimg = 0
          }
        } else {
          this.$message.error(result.msg)
        }
      })
    },
    //守信激励
    getSxjlList () {
      let data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      }
      const res = sxjl_list(this.sendParam(data));
      Promise.resolve(res).then(value => {  //处理返回的Promise
        let key = this.RsaDecrypt(value.data.encrypted)
        let result = JSON.parse(this.AesDecrypt(value.data.requestData, key))
        if (result.code == 200 && res.data !== null) {
          this.SxjlList = result.data.list
          this.Sxjltxt = result.data.total
          if (result.data.total == 0) {
            this.sxjlimg = 0
          }
        } else {
          this.$message.error(result.msg)
        }
      })
    },
    //失信惩戒
    getSxcjList () {
      let data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      }
      const res = sxcj_list(this.sendParam(data));
      Promise.resolve(res).then(value => {  //处理返回的Promise
        let key = this.RsaDecrypt(value.data.encrypted)
        let result = JSON.parse(this.AesDecrypt(value.data.requestData, key))
        if (result.code == 200 && res.data !== null) {
          this.SxcjList = result.data.list
          this.Sxcjtxt = result.data.total
          if (result.data.total == 0) {
            this.sxcjimg = 0
          }
        } else {
          this.$message.error(result.msg)
        }
      })
    },
    //重大税收违法
    getZdsswf () {
      let data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      }
      const res = zdsswf(this.sendParam(data));
      Promise.resolve(res).then(value => {  //处理返回的Promise
        let key = this.RsaDecrypt(value.data.encrypted)
        let result = JSON.parse(this.AesDecrypt(value.data.requestData, key))
        if (result.code == 200 && res.data !== null) {
          this.Zdsswf = result.data.list
          this.Zdsswftxt = result.data.total
          if (result.data.total == 0) {
            this.zdsswfimg = 0
          }
        } else {
          this.$message.error(result.msg)
        }
      })
    },
    //安全生产失信
    getAqsc () {
      let data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      }
      const res = aqsc(this.sendParam(data));
      Promise.resolve(res).then(value => {  //处理返回的Promise
        let key = this.RsaDecrypt(value.data.encrypted)
        let result = JSON.parse(this.AesDecrypt(value.data.requestData, key))
        if (result.code == 200 && res.data !== null) {
          this.Aqsc = result.data.list
          this.Aqsctxt = result.data.total
          if (result.data.total == 0) {
            this.aqscsximg = 0
          }
        } else {
          this.$message.error(result.msg)
        }
      })
    },
    //严重拖欠工资
    gettQnmggz () {
      let data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword

      }
      const res = tqnmggz(this.sendParam(data));
      Promise.resolve(res).then(value => {  //处理返回的Promise
        let key = this.RsaDecrypt(value.data.encrypted)
        let result = JSON.parse(this.AesDecrypt(value.data.requestData, key))
        if (result.code == 200 && res.data !== null) {
          this.Qnmggz = result.data.list
          this.Qnmggztxt = result.data.total
          if (result.data.total == 0) {
            this.yztqgzimg = 0
          }
        } else {
          this.$message.error(result.msg)
        }
      })
    },
    //信用评分
    getXYPFDetail () {
      let data = {
        companyId: this.keyword
      }
      const res = XYPFDetail(this.sendParam(data));
      Promise.resolve(res).then(value => {  //处理返回的Promise
        let key = this.RsaDecrypt(value.data.encrypted)
        let result = JSON.parse(this.AesDecrypt(value.data.requestData, key))
        if (result.code == 200 && res.data !== null) {
          this.XYPFDetailList = result.data
          if (result.data.totalScore) {
            this.XYPFText = 1
          }
        } else {
          this.$message.error(result.msg)
        }
      })
    },

  }
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  box-sizing: border-box;
  background-color: #f5f6fa;
  padding: 109px 300px;
  .header {
    height: 100px;
    background-color: #fff;
    box-sizing: border-box;
    .list {
      padding: 33px 42px;
      background-color: #fff;
      .listTitle {
        display: flex;
        align-items: center;
        .listTitleText {
          font-size: 22px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2a2a2a;
          line-height: 17px;
          margin-right: 17px;
        }
        .status {
          width: 44px;
          height: 24px;
          background: #ffffff;
          border: 1px solid rgba(69, 192, 110, 0.7);
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #4fb270;
          line-height: 17px;
          text-align: center;
          line-height: 24px;
        }
      }
      .listBtn {
        margin-top: 15px;
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #2a2a2a;
        line-height: 17px;
      }
    }
  }
  .basis {
    margin-top: 40px;
    height: 160px;
    width: 100%;
    border-bottom: 1px solid #e8e9f2;

    .title {
      border-left: 4px solid #2981ee;
      font-size: 18px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2981ee;
      line-height: 17px;
      height: 17px;
      padding-left: 10px;
      margin-bottom: 12px;
    }
    .titleTop {
      box-sizing: border-box;
      border-top: 1px solid #e8e9f2;
      height: 65px;
      display: flex;
      .stateContent {
        width: 457px;
        background-color: #fff;
        border-left: 1px solid #e8e9f2;
        text-align: center;
        line-height: 65px;
      }
      .state {
        text-align: center;
        padding: 20px;
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #2a2a2a;
        line-height: 22px;
        border-left: 1px solid #e8e9f2;
        height: 65px;
        width: 200px;
        background-color: #ebf4ff;
        box-sizing: border-box;
      }
    }
  }
  .basisList {
    width: 100%;
    height: 124px;
    margin-top: 24px;
    background-color: #eff6ff;
    display: flex;
    .chooselistSon {
      background-color: #fff;
    }
    .listSon {
      width: 187px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span {
        font-size: 18px;
      }
      .colortxt {
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #d32417;
        line-height: 25px;
      }
    }
  }
  .illegalDetails {
    margin-top: 20px;
    min-height: 500px;
    box-sizing: border-box;
    .noData {
      width: 100%;
      height: 437px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
    }
    .title {
      padding-left: 12px;
      border-left: 4px solid #2981ee;
      font-size: 18px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2981ee;
      line-height: 17px;
    }
    .illegalDetailsBox {
      margin-top: 13px;
      min-height: 450px;
      box-sizing: border-box;

      .xuke {
        border-bottom: 1px solid #e8e9f2;
        min-height: 82px;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        .left {
          min-height: 82px;
          background-color: #f7faff;
          opacity: 0.5;
          width: 204px;
          line-height: 82px;
          text-align: center;
        }
        .right {
          min-height: 82px;
          background-color: #fff;
          width: 1120px;
          display: flex;
          box-sizing: border-box;
          padding: 15px 10px;
        }
      }
      .DetailsBox {
        display: flex;
        justify-content: space-between;
        height: 58px;
        border-bottom: 1px solid #e8e9f2;
        .boxState {
          height: 100%;
          background-color: #f7faff;
          opacity: 0.5;
          width: 200px;
          line-height: 58px;
          box-sizing: border-box;
          font-size: 14px;
          text-align: center;
        }
        .boxCont {
          height: 100%;
          width: 455px;
          text-align: center;
          line-height: 58px;
          background-color: #fff;
        }
      }
    }
  }

  .credit {
    width: 100%;
    height: 437px;
    background-color: #fff;
    margin-top: 25px;
    padding-top: 54px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .top {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      .fenshu {
        font-size: 48px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #000000;
        line-height: 47px;
        position: absolute;
      }
      .level {
        position: absolute;
        top: 80px;
        width: 84px;
        height: 26px;
        background: #e64332;
        border-radius: 4px;
        font-size: 18px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #ffffff;
        line-height: 26px;
        text-align: center;
      }
      .btn {
        position: absolute;
        top: 120px;
        font-size: 24px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2a2a2a;
        line-height: 24px;
        white-space: nowrap;
      }
    }
  }
  .administrative {
    margin-top: 20px;
    min-height: 560px;
    box-sizing: border-box;
    .noData {
      width: 100%;
      height: 437px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
    }
    .title {
      padding-left: 12px;
      border-left: 4px solid #2981ee;
      font-size: 18px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2981ee;
      line-height: 17px;
    }
    .illegalDetailsBox {
      margin-top: 13px;
      height: 450px;
      box-sizing: border-box;
      .xuke {
        border-bottom: 1px solid #e8e9f2;
        height: 82px;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        .left {
          height: 100%;
          background-color: #f7faff;
          opacity: 0.5;
          width: 204px;
          line-height: 82px;
          text-align: center;
        }
        .right {
          height: 100%;
          background-color: #fff;
          width: 1120px;
          display: flex;
          box-sizing: border-box;
          padding: 10px 10px;
        }
      }
      .DetailsBox {
        display: flex;
        justify-content: space-between;
        height: 58px;
        border-bottom: 1px solid #e8e9f2;
        .boxState {
          height: 100%;
          background-color: #f7faff;
          opacity: 0.5;
          width: 200px;
          line-height: 58px;
          box-sizing: border-box;
          font-size: 14px;
          text-align: center;
        }
        .boxCont {
          height: 100%;
          width: 455px;
          background-color: #fff;
          text-align: center;
          line-height: 58px;
        }
      }
    }
  }
  .trustworthyIncentive {
    margin-top: 20px;
    min-height: 380px;
    box-sizing: border-box;
    .noData {
      width: 100%;
      height: 437px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
    }
    .title {
      padding-left: 12px;
      border-left: 4px solid #2981ee;
      font-size: 18px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2981ee;
      line-height: 17px;
    }
    .illegalDetailsBox {
      margin-top: 13px;
      height: 380px;
      box-sizing: border-box;
      .xuke {
        border-bottom: 1px solid #e8e9f2;
        height: 82px;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        .left {
          height: 100%;
          background-color: #f7faff;
          opacity: 0.5;
          width: 204px;
          line-height: 82px;
          text-align: center;
        }
        .right {
          height: 100%;
          background-color: #fff;
          width: 1120px;
          display: flex;
          box-sizing: border-box;
          padding: 10px 10px;
        }
      }
    }
  }
  .disciplinary {
    margin-top: 20px;
    min-height: 500px;
    box-sizing: border-box;
    .noData {
      width: 100%;
      height: 437px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
    }
    .title {
      padding-left: 12px;
      border-left: 4px solid #2981ee;
      font-size: 18px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2981ee;
      line-height: 17px;
    }
    .illegalDetailsBox {
      margin-top: 13px;
      height: 500px;
      box-sizing: border-box;
      .xuke {
        border-bottom: 1px solid #e8e9f2;
        height: 82px;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        .left {
          height: 100%;
          background-color: #f7faff;
          opacity: 0.5;
          width: 204px;
          line-height: 82px;
          text-align: center;
        }
        .right {
          height: 100%;
          background-color: #fff;
          width: 1120px;
          display: flex;
          box-sizing: border-box;
          padding: 10px 10px;
        }
      }
    }
  }
  .taxViolation {
    margin-top: 20px;
    min-height: 950px;
    box-sizing: border-box;
    .noData {
      width: 100%;
      height: 437px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
    }
    .title {
      padding-left: 12px;
      border-left: 4px solid #2981ee;
      font-size: 18px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2981ee;
      line-height: 17px;
    }
    .illegalDetailsBox {
      margin-top: 13px;
      height: 500px;
      box-sizing: border-box;
      .xuke {
        border-bottom: 1px solid #e8e9f2;
        height: 82px;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        .left {
          height: 100%;
          background-color: #f7faff;
          opacity: 0.5;
          width: 204px;
          padding: 10px 10px;
          // line-height: 82px;
          // text-align: center;
          box-sizing: border-box;
        }
        .right {
          height: 100%;
          background-color: #fff;
          width: 1120px;
          display: flex;
          box-sizing: border-box;
          padding: 10px 10px;
        }
      }
    }
  }
  .production {
    margin-top: 20px;
    min-height: 500px;
    box-sizing: border-box;
    .noData {
      width: 100%;
      height: 437px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
    }
    .title {
      padding-left: 12px;
      border-left: 4px solid #2981ee;
      font-size: 18px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2981ee;
      line-height: 17px;
    }
    .illegalDetailsBox {
      margin-top: 13px;
      height: 500px;
      box-sizing: border-box;
      .xuke {
        border-bottom: 1px solid #e8e9f2;
        height: 82px;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        .left {
          height: 100%;
          background-color: #f7faff;
          opacity: 0.5;
          width: 204px;
          line-height: 82px;
          text-align: center;
        }
        .right {
          height: 100%;
          background-color: #fff;
          width: 1120px;
          display: flex;
          box-sizing: border-box;
          padding: 10px 10px;
        }
      }
    }
  }
  .wages {
    margin-top: 20px;
    min-height: 500px;
    box-sizing: border-box;
    .noData {
      width: 100%;
      height: 437px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
    }
    .title {
      padding-left: 12px;
      border-left: 4px solid #2981ee;
      font-size: 18px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2981ee;
      line-height: 17px;
    }
    .illegalDetailsBox {
      margin-top: 13px;
      height: 500px;
      box-sizing: border-box;
      .xuke {
        border-bottom: 1px solid #e8e9f2;
        height: 82px;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        .left {
          height: 100%;
          background-color: #f7faff;
          opacity: 0.5;
          width: 204px;
          line-height: 82px;
          text-align: center;
        }
        .right {
          height: 100%;
          background-color: #fff;
          width: 1120px;
          display: flex;
          box-sizing: border-box;
          padding: 10px 10px;
        }
      }
    }
  }
}
</style>